//routes.js:
import Home from './pages/Home';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Sources from './pages/Sources';
import AddSource from './pages/AddSource';
import NewsPage from './pages/NewsPage';
import Login from './pages/Login';
// import Register from './pages/Register';
import NotFound from './pages/NotFound';
import News from "./pages/News"; 

import {
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  DatabaseOutlined,
  FileAddOutlined,
  DeleteOutlined
} from '@ant-design/icons';

// مسیرهای عمومی (خارج داشبورد)
export const publicRoutes = [
  { path: '/', element: <Login /> },
  // { path: '/register', element: <Register /> },
  { path: '*', element: <NotFound /> },
];

// مسیرهای داشبورد
export const dashboardRoutes = [
  { path: 'home', label: 'داشبورد', icon: <DashboardOutlined />, element: <Home /> },
  { path: 'users', label: 'کاربران', icon: <UserOutlined />, element: <Users /> },
  { path: 'settings', label: 'تنظیمات', icon: <SettingOutlined />, element: <Settings /> },
  { path: 'sources', label: 'Sources', icon: <DatabaseOutlined />, element: <Sources /> },
  { path: 'addSource', label: 'Add Source', icon: <FileAddOutlined />, element: <AddSource /> },
  { path: 'news/:id', element: <NewsPage /> },
  { path: "news",     label: "اخبار",     icon: <DeleteOutlined />,    element: <News /> }, // جدید
  { path: '*', element: <NotFound /> },
];
